import { render } from "./PointSelectModal.vue?vue&type=template&id=67300aeb&scoped=true"
import script from "./PointSelectModal.vue?vue&type=script&lang=js"
export * from "./PointSelectModal.vue?vue&type=script&lang=js"

import "./PointSelectModal.vue?vue&type=style&index=0&id=67300aeb&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67300aeb"]])

export default __exports__